import axios from 'axios';

import { findIndexInArray, getLastUserInfo } from 'js/library/utils/helpers.js';
import { loginUser } from 'js/library/services/AuthenticationManager.js';
import { login } from 'js/library/utils/API/login';
import { getChannelTokenUidNull } from 'js/library/utils/API/getChannelTokenUidNull_v1';
import cfac22 from '../cfac22';

//buscando usuario p/ login
export function getUserInfo_v1(queryPartnerAPI, userInfo) {
  return new Promise((resolve, reject) => {
    getChannelTokenUidNull()
      .then((result) => {
        //console.log('RESULTADO GET CHANNEL TOKEN C/ UID NULL ===>', result);

        //TODO capturar sessionId e transactionId
        axios
          .post(
            cfac22('API_HOST_V1') + 'getUserInfo_v1',
            {
              triiboHeader: {
                apiToken: cfac22('apiToken'),
                channelGroup: cfac22('channelGroup'),
                channelName: cfac22('channelName'),
                uId: null,
                channelTokenId: result,
                channelId: cfac22('channelId'),
                sessionId: '001',
                transactionId: '002',
              },
              queryPartnerAPI,
              userInfo,
            },
            {
              headers: {
                'Full-Url': window.location.href,
              },
            }
          )
          .then(async (result) => {
            //console.log('RESULTADO DA API GET INFO ===>', result);
            const cellPhone =
              userInfo.contactList[findIndexInArray(userInfo.contactList, 'type', 'cellPhone')]
                .value;

            if (result.data.success.userInfo === false) {
              if (localStorage.getItem('localLogin') === 'SS') {
                window.pathname = '/show-de-premios/cadastro';
                localStorage.removeItem('localLogin');
              } else {
                window.pathname = '/cadastroUsuario';
              }
              resolve({ cellPhone: cellPhone, userInfo: false });
            } else {
              //logando user no firebase auth
              localStorage.removeItem('userInfoAuxiliar');
              await loginUser(
                result.data.success.userInfo.triiboId.replace(/[,]/gi, '.'),
                result.data.success.userInfo.passPhrase
              );

              //LÓGICA PARA ENCAMINHAR PARA URL DINÂMICA
              if (
                localStorage.getItem('loginOption') === '3' &&
                localStorage.getItem('loginRedirect') !== undefined
              ) {
                window.pathname = localStorage.getItem('loginRedirect');
                localStorage.removeItem('loginOption');
                localStorage.removeItem('loginRedirect');
              } else {
                if (localStorage.getItem('localLogin') === 'SS') {
                  window.pathname = '/show-de-premios';
                  localStorage.removeItem('localLogin');
                } else {
                  window.pathname = document.location.origin + '/';
                }
              }

              resolve({
                cellPhone: cellPhone,
                userInfo: result.data.success.userInfo,
              });
            }
          })
          .catch((error) => {
            //console.log('ERROR GET USER INFO ===>', error);
            reject(error);
          });
      })
      .catch((error) => {
        //console.log('ERROR GET CHANNEL TOKEN ===>', error);
        reject(error);
      });
  });
}

//verificando se o usuario existe com o cpf e cadastrando no authentication
export function getUserInfo_v1WithDocument(userInfo, cellPhone) {
  return new Promise((resolve, reject) => {
    getChannelTokenUidNull()
      .then((result) => {
        let queryPartnerAPI = ['getUserInfo'];

        //TODO capturar sessionId e transactionId
        axios
          .post(cfac22('API_HOST_V1') + 'getUserInfo_v1', {
            triiboHeader: {
              apiToken: cfac22('apiToken'),
              channelGroup: cfac22('channelGroup'),
              channelName: cfac22('channelName'),
              uId: null,
              channelTokenId: result,
              channelId: cfac22('channelId'),
              sessionId: '001',
              transactionId: '002',
            },
            queryPartnerAPI,
            userInfo,
          })
          .then(async (result) => {
            //console.log('RESULTADO DA API GET INFO WITH DOCUMENT ===>', result.data);

            if (result.data.success.userInfo === null) {
              //registrando login anônimo, caso exista
              const oldUserInfo = getLastUserInfo();
              const isAnonymous =
                oldUserInfo !== null ||
                oldUserInfo.triiboId.indexOf('@anonymous-triibo.com.br') >= 0;
              const anonymousTriiboId = isAnonymous ? oldUserInfo.triiboId : null;

              const resultCreate = await login(
                '+' + cellPhone.replace(/\D/g, ''),
                anonymousTriiboId
              );

              resolve(resultCreate.data.userInfo.user.uId);
            } else {
              resolve(result.data.success.userInfo.uId);
            }
          })
          .catch((error) => {
            //console.log('ERROR GET USER INFO WITH CELLPHONE===>', error);
            reject(error);
          });
      })
      .catch((error) => {
        //console.log('ERROR GET CHANNEL TOKEN ===>', error);
        reject(error);
      });
  });
}

export function createUserInfo(cellPhone) {
  return new Promise(async (resolve, reject) => {
    try {
      const oldUserInfo = getLastUserInfo();
      let isAnonymous = oldUserInfo !== null;
      isAnonymous = isAnonymous
        ? oldUserInfo.triiboId.indexOf('@anonymous-triibo.com.br') >= 0
        : false;
      const anonymousTriiboId = isAnonymous ? oldUserInfo.triiboId : null;

      const resultCreate = await login('+' + cellPhone.replace(/\D/g, ''), anonymousTriiboId);

      resolve(resultCreate.data.userInfo.user.uId);
    } catch (error) {
      reject(error);
    }
  });
}
//busca simples
export function getUserInfoBasic_v1(queryPartnerAPI, userInfo) {
  return new Promise((resolve, reject) => {
    getChannelTokenUidNull()
      .then((result) => {
        //console.log('RESULTADO GET CHANNEL TOKEN C/ UID NULL ===>', result);

        //TODO capturar sessionId e transactionId
        axios
          .post(cfac22('API_HOST_V1') + 'getUserInfo_v1', {
            triiboHeader: {
              apiToken: cfac22('apiToken'),
              channelGroup: cfac22('channelGroup'),
              channelName: cfac22('channelName'),
              uId: null,
              channelTokenId: result,
              channelId: cfac22('channelId'),
              sessionId: '001',
              transactionId: '002',
            },
            queryPartnerAPI,
            userInfo,
          })
          .then((result) => {
            //console.log('RESULTADO DA API GET INFO ===>', result);

            return resolve(result.data.success.userInfo);
          })
          .catch((error) => {
            //console.log("ERROR GET USER INFO ===>", error);

            return reject(error);
          });
      })
      .catch((error) => {
        //console.log('ERROR GET CHANNEL TOKEN ===>', error);
        return reject(error);
      });
  });
}
